import React from 'react';
import SEO from "../common/SEO";
import Layout from "../common/Layout";
import BreadcrumbOne from "../elements/breadcrumb/BreadcrumbOne";
import { FiCheck } from "react-icons/fi";
import SectionTitle from "../elements/sectionTitle/SectionTitle";
import ContactOne from "../elements/contact/ContactOne";
import ScrollAnimation from "react-animate-on-scroll";


const HostingSol = () => {
    return (
        <>
            <SEO title="Services" />
            <Layout>
                <BreadcrumbOne 
                    title="Hosting Solutions"
                    rootUrl="/"
                    parentUrl="Home"
                    currentUrl="Hosting Solutions"
                />
            <div className="main-content">
            
        <div className="rn-splite-style bg-color-blackest">
            <div className="split-wrapper">
                <div className="row no-gutters radius-10 align-items-center">
                    <div className="order-2 order-lg-1 col-lg-12 col-xl-6 col-12">
                        <div className="split-inner">
                            <ScrollAnimation 
                            animateIn="fadeInUp"
                            animateOut="fadeInOut"
                            animateOnce={true}>
                                <p className="description">Hosting solutions will be provided in different servers based on the customer specifications and need. In focus to higher performance, reliability and security the hosting will be done on Azure/AWS servers.</p>
                            </ScrollAnimation>
                        </div>
                    </div>
                    <div className="order-1 order-lg-2 col-lg-12 col-xl-6 col-12">
                        <div className="thumbnail">
                            <img src="./images/portfolio/hosting1.jpg" alt="hosting" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
        </div>
        </Layout>
        </>
    )
}
export default HostingSol;